import React, { useState } from 'react';
import axios from 'axios';
import { Star, Check, Loader2 } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const fmt = (iso) => new Date(iso).toLocaleString([], { month: 'short', day: 'numeric', year: 'numeric', hour: '2-digit', minute: '2-digit' });

export const ReviewRequestButton = ({ order, headers, onSent }) => {
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState({ text: '', err: false });
  const cancelled = order.status === 'cancelled';
  const sentAt = order.review_requested_at;

  const send = async () => {
    if (sentAt && !window.confirm('A review request was already sent. Send it again?')) return;
    setBusy(true); setMsg({ text: '', err: false });
    try {
      const { data } = await axios.post(`${API}/admin/orders/${order.id}/request-review`, {}, { headers });
      onSent(order.id, data.review_requested_at);
      setMsg({ text: `Review request emailed to ${data.email}.`, err: false });
    } catch (e) { setMsg({ text: e?.response?.data?.detail || 'Could not send the request.', err: true }); }
    finally { setBusy(false); }
  };

  return (
    <div data-testid={`review-request-panel-${order.id}`} className="rounded-lg border border-neutral-200 dark:border-neutral-800 bg-white dark:bg-[#141416] p-4 flex flex-wrap items-center justify-between gap-3">
      <div className="text-[12px] text-neutral-500 flex-1 min-w-[200px]">
        {cancelled ? <span>Review requests are not available for cancelled orders.</span>
          : sentAt ? <span data-testid={`review-request-sent-${order.id}`} className="inline-flex items-center gap-1 text-emerald-600"><Check size={12} /> Review request sent {fmt(sentAt)}</span>
          : <span>Ask the customer to review their experience by email.</span>}
        {msg.text && <div data-testid={`review-request-msg-${order.id}`} className={`mt-1 ${msg.err ? 'text-red-600' : 'text-neutral-600 dark:text-neutral-400'}`}>{msg.text}</div>}
      </div>
      <button data-testid={`request-review-btn-${order.id}`} onClick={send} disabled={busy || cancelled}
        className="inline-flex items-center gap-1.5 rounded-md bg-amber-500 hover:bg-amber-600 text-white text-[12.5px] font-semibold px-3 py-2 disabled:opacity-50 transition-colors">
        {busy ? <Loader2 size={13} className="animate-spin" /> : <Star size={13} className="fill-white" />}
        {busy ? 'Sending…' : sentAt ? 'Send again' : 'Request review'}
      </button>
    </div>
  );
};
